import MenuItem from '@mui/material/MenuItem';
import {BaseOption} from '@refinedev/core';

import {Field} from '@minimal/components/hook-form';

type TissotRhfSelectProps = {
  id: string;
  name: string;
  label: string;
  options: BaseOption[];
  required?: boolean;
  disabled?: boolean;
};

export const TissotRhfSelect = ({id, name, label, options, required = true, disabled}: TissotRhfSelectProps) => {
  return (
    <Field.Select
      id={id}
      name={name}
      label={label}
      disabled={disabled}
      slotProps={{
        inputLabel: {
          required,
        },
      }}
    >
      {options.map(({label, value}) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </Field.Select>
  );
};
